import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, Loading } from "@/components/common";
import { Button } from "@/components/ui/button";
import { ScrollText } from "lucide-react";

const LABELS = {
  payslip_generated: "Payslip generated", payslip_revoked: "Payslips revoked",
  payslip_bulk_download: "Bulk download", salary_revised: "Salary revised",
  employee_created: "Employee created", employee_updated: "Employee updated",
  employee_deactivated: "Employee deactivated", password_reset: "Password reset",
  password_changed: "Password changed", settings_changed: "Settings changed",
  logo_uploaded: "Logo uploaded", designation_created: "Designation created",
  designation_updated: "Designation updated", designation_deleted: "Designation deleted",
  holiday_created: "Holiday added", holiday_updated: "Holiday updated",
  holiday_deleted: "Holiday deleted", holiday_bulk_added: "Holidays bulk-added",
  pt_slabs_updated: "PT slabs updated", setup_completed: "Setup completed",
};

export default function Audit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => { api.get("/audit?limit=300").then(({ data }) => setLogs(data)).catch((e) => { toastErr(e); setLogs([]); }); }, []);
  const toastErr = () => {};

  if (logs === null) return <Loading />;

  return (
    <div>
      <PageHeader title="Audit Log" description="Every sensitive action is recorded here — generation, revocation, salary revisions, password resets and settings changes." testid="audit-page" />
      {logs.length === 0 ? (
        <div className="border border-dashed rounded-md py-16 text-center text-sm text-muted-foreground">No activity recorded yet.</div>
      ) : (
        <div className="bg-card border border-border rounded-md overflow-hidden" data-testid="audit-list">
          <div className="hidden md:grid grid-cols-12 px-5 py-2.5 label-caps border-b border-border bg-secondary/50">
            <div className="col-span-3">When</div><div className="col-span-3">Action</div>
            <div className="col-span-3">Target</div><div className="col-span-3">Actor</div>
          </div>
          <div className="divide-y divide-border">
            {logs.map((l) => (
              <div key={l.id} className="grid grid-cols-1 md:grid-cols-12 gap-1 md:gap-0 px-5 py-3 text-sm" data-testid={`audit-row-${l.id}`}>
                <div className="md:col-span-3 text-muted-foreground tabular text-xs md:text-sm">{fmt(l.timestamp)}</div>
                <div className="md:col-span-3 font-medium">{LABELS[l.action] || l.action}</div>
                <div className="md:col-span-3 text-muted-foreground truncate">{l.target}</div>
                <div className="md:col-span-3 text-muted-foreground truncate">{l.actor}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function fmt(ts) {
  try {
    return new Date(ts).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return ts; }
}
